export const timeoutConfig = 3000;
export const US_SLASH_DATE_FORMAT = 'MM/dd/YYYY';
export const ISO_DATE_FORMAT = 'YYYY-MM-dd';
export const CORRELATION_ID_COOKIE_NAME: string = 'ZCI_CORRELATION_ID';
export const ZCI_CORRELATION_ID_NAMESPACE = 'fe6aab71-d408-4f2c-a72b-659cb8db8c9e';
